export default "__VITE_ASSET__f1e84f97__"